import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { SkywCommonProps } from 'libs/types';
import { MEDIA_SIZE_LIST } from 'libs/const';

import Clock from './Clock';

const LogoBox = styled.div`
  img {
    width: 120px;
  }
`;

const InfoBox = styled.div``;

const Title = styled.h1`
  font-size: 42px;
  font-weight: 600;
  line-height: 1;
`;

const ClockBox = styled.div`
  height: 27px;
`;

const Container = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[1]}px`}) {
    ${Title} {
      font-size: 28px;
    }

    ${LogoBox} {
      img {
        width: 80px;
      }
    }
  }
`;

interface HeaderProps extends SkywCommonProps {
  title: string;
}

const Header = ({ title, obsId }: HeaderProps) => {
  return (
    <Container>
      <Link to="/">
        <LogoBox>
          <img src="/assets/skyw/owl_logo.png" alt="logo" />
        </LogoBox>
      </Link>
      <InfoBox>
        <Title>{title}</Title>
        <ClockBox>
          <Clock obsId={obsId} />
        </ClockBox>
      </InfoBox>
    </Container>
  );
};

export default Header;
